import { rest } from 'msw'

export default [
  /**
   * 警報履歴情報
   */
  rest.get('/swc-api/nodes/:nodeId/alarm-history', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const timeFrom = req.url.searchParams.get('time_from')
    const timeTo = req.url.searchParams.get('time_to')
    const data = [
      {
          "time": 1646010196000,
          "dataset_id": "gw-005",
          "field_name": "D005608_03",
          "display_name": "純水送水流量(缶調合B)  異常低",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646007967000,
          "dataset_id": "gw-005",
          "field_name": "D005610_12",
          "display_name": "No.1アニオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646007847000,
          "dataset_id": "gw-005",
          "field_name": "D005610_08",
          "display_name": "No.1カチオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646007847000,
          "dataset_id": "gw-005",
          "field_name": "D005610_09",
          "display_name": "No.1カチオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646002856000,
          "dataset_id": "gw-005",
          "field_name": "D005612_23",
          "display_name": "No.2カチオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646002796000,
          "dataset_id": "gw-005",
          "field_name": "D005612_22",
          "display_name": "No.2カチオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005612_22",
          "display_name": "No.2カチオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005604_03",
          "display_name": "No.1ﾚｼﾞﾝｷｬｯﾁｬｰ出口圧力 異常高",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005608_01",
          "display_name": "純水送水流量(缶調合Ａ)  異常低",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005608_03",
          "display_name": "純水送水流量(缶調合B)  異常低",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005602_32",
          "display_name": "No.1ﾚｼﾞﾝｷｬｯﾁｬｰ入口圧力 異常高",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005612_23",
          "display_name": "No.2カチオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005612_07",
          "display_name": "No.2純水装置 通水量超過（採水継続）",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005612_10",
          "display_name": "No.2純水装置 アニオン 通水負荷量超過（採水継続）",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005616_06",
          "display_name": "純水装置 軽故障",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005616_12",
          "display_name": "純水装置 流量異常",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005616_05",
          "display_name": "純水装置 中故障",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005606_13",
          "display_name": "塩酸流量 異常低",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005616_13",
          "display_name": "純水装置 工程異常",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005614_08",
          "display_name": "No.2再生工程 ｶﾁｵﾝ塔通薬工程遅延",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005610_08",
          "display_name": "No.1カチオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005610_09",
          "display_name": "No.1カチオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1646000035000,
          "dataset_id": "gw-005",
          "field_name": "D005610_12",
          "display_name": "No.1アニオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": false
      },
      {
          "time": 1645993191000,
          "dataset_id": "gw-005",
          "field_name": "D005616_13",
          "display_name": "純水装置 工程異常",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645993191000,
          "dataset_id": "gw-005",
          "field_name": "D005614_08",
          "display_name": "No.2再生工程 ｶﾁｵﾝ塔通薬工程遅延",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645992771000,
          "dataset_id": "gw-005",
          "field_name": "D005616_05",
          "display_name": "純水装置 中故障",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645992771000,
          "dataset_id": "gw-005",
          "field_name": "D005606_13",
          "display_name": "塩酸流量 異常低",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645992471000,
          "dataset_id": "gw-005",
          "field_name": "D005616_06",
          "display_name": "純水装置 軽故障",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645992471000,
          "dataset_id": "gw-005",
          "field_name": "D005616_12",
          "display_name": "純水装置 流量異常",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645989887000,
          "dataset_id": "gw-005",
          "field_name": "D005612_10",
          "display_name": "No.2純水装置 アニオン 通水負荷量超過（採水継続）",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645989047000,
          "dataset_id": "gw-005",
          "field_name": "D005612_07",
          "display_name": "No.2純水装置 通水量超過（採水継続）",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645966524000,
          "dataset_id": "gw-005",
          "field_name": "D005612_23",
          "display_name": "No.2カチオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645945126000,
          "dataset_id": "gw-005",
          "field_name": "D005602_32",
          "display_name": "No.1ﾚｼﾞﾝｷｬｯﾁｬｰ入口圧力 異常高",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645940677000,
          "dataset_id": "gw-005",
          "field_name": "D005608_03",
          "display_name": "純水送水流量(缶調合B)  異常低",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645936233000,
          "dataset_id": "gw-005",
          "field_name": "D005608_01",
          "display_name": "純水送水流量(缶調合Ａ)  異常低",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645900120000,
          "dataset_id": "gw-005",
          "field_name": "D005612_26",
          "display_name": "No.2アニオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645896578000,
          "dataset_id": "gw-005",
          "field_name": "D005604_03",
          "display_name": "No.1ﾚｼﾞﾝｷｬｯﾁｬｰ出口圧力 異常高",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645890330000,
          "dataset_id": "gw-005",
          "field_name": "D005612_22",
          "display_name": "No.2カチオン樹脂センサー(1) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645890330000,
          "dataset_id": "gw-005",
          "field_name": "D005612_24",
          "display_name": "No.2カチオン樹脂センサー(3) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645890330000,
          "dataset_id": "gw-005",
          "field_name": "D005612_25",
          "display_name": "No.2カチオン樹脂センサー(4) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645890330000,
          "dataset_id": "gw-005",
          "field_name": "D005612_28",
          "display_name": "No.2アニオン樹脂センサー(3) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      },
      {
          "time": 1645890330000,
          "dataset_id": "gw-005",
          "field_name": "D005612_27",
          "display_name": "No.2アニオン樹脂センサー(2) 異常低(採水継続)",
          "alarm_level": 2,
          "value": true
      }
    ]
    const result = data.filter(item => item.time >= timeFrom && item.time <= timeTo)
    return res(
      ctx.status(200),
      ctx.json(result)
    )
  }),
]
